import { render, staticRenderFns } from "./TrainingPathReferences.vue?vue&type=template&id=44810f0d&"
import script from "./TrainingPathReferences.vue?vue&type=script&lang=ts&"
export * from "./TrainingPathReferences.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports